export default {
  campaign: {
    include_campaign_agent_ids: true,
    include_campaign_agents: true,
    include_campaign_image: true,
    include_campaign_priority_campaign_user_ids: true,
  },
  campaignQuote: {
    include_campaign_quote_campaign: true,
    include_campaign_quote_priority_campaign_user_ids: true,
  },
  campaignInspection: {
    include_campaign_agents: true,
    include_campaign_inspection_campaign: true,
  },
  order: {
    include_order_bundle_items: true,
    include_order_campaign: true,
    include_order_item_agency: true,
    include_order_item_agents: true,
    include_order_item_artwork: true,
    include_order_item_due_date: true,
    include_order_items: true,
    include_order_priority_campaign_user_ids: true,
    include_order_publication_edition: true,
    include_order_publication: true,
  },
  orderItem: {
    exclude_hidden_campaigns: true,
    include_agent_user: true,
    include_order_item_agents: true,
    include_order_item_campaign: true,
    include_order_item_last_completed_task: true,
    include_order_item_order: true,
    include_order_item_service: true,
    include_order_item_priority_campaign_user_ids: true,
  },
}
